import { render } from "./FirePaidBills.vue?vue&type=template&id=2bd03015"
import script from "./FirePaidBills.vue?vue&type=script&lang=js"
export * from "./FirePaidBills.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__